const STORE_KEY = 'OUR_VARIANTS'

export const FETCH_OUR_VARIANTS = `${STORE_KEY}/FETCH_OUR_VARIANTS`
